// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__Pw-So","title":"Section_title__Y_XgY","content":"Section_content__2xFw7","expandSection":"Section_expandSection__188n6"};